import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-uig-order-confirmation-thank-you-message',
    templateUrl: './uig-order-confirmation-thank-you-message.component.html',
    styleUrls: ['./uig-order-confirmation-thank-you-message.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigOrderConfirmationThankYouMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
